import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sub-menu scrollbox" }
const _hoisted_2 = { class: "col gap-15 bg-h" }
const _hoisted_3 = {
  key: 1,
  class: "col h-full w-full pad-xl",
  style: {"width":"35rem","height":"32rem"}
}
const _hoisted_4 = { class: "row w-full mtop-02" }
const _hoisted_5 = {
  key: 0,
  class: "h-full w-full mtop-04 col"
}
const _hoisted_6 = { class: "h-full sub-menu-right right-col" }
const _hoisted_7 = { class: "mleft-04 col gap-10" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "col gap-04 mtop-04" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "mtop-01 row" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}

import { ref, computed, onMounted, nextTick } from 'vue';
import taskBoxColumn from './taskBoxColumn.vue';
import patientChange from '@/views/mainMenu/patientChange.vue';
import taskNotesChat from './taskNotesChat.vue';
import { taskPriorityTypes } from '@/functions/office';
import officeapi from '@/api/officeapi';
import { useRoute } from 'vue-router';
import { useAppUserStore } from '@/stores/appUser';
import { apiDateString } from '@/api/apicommon';
import { useUiStore } from '@/stores/ui';
import { useI18n } from "vue-i18n";
import PersonService from "@/services/PersonService";

import { TaskStatus, TaskPriorityChange, TaskStatusChange } from '@/models/task.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'editTask',
  props: {
  task: {
    type: Object,
    required: false,
  },
  pwrPatient: {
    type: Object,
    required: false,
  },
  canChangePatient: {
    type: Boolean,
    default: true,
  },
  hasInputTaskNote: {
    type: Boolean,
    default: true,
  },
  startTaskBox: {
    type: String,
    required: false,
  },
},
  emits: ["changed", "changedPriority", "changedStatus", "changeShowDate"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const route = useRoute()
const appUserStore = useAppUserStore()
const uiStore = useUiStore();

const emits = __emit
const props = __props


const focusRef = ref(null)
const taskNoteInputRef = ref("")
const dropd = ref("")
const autoChangePriority = ref(props.task ? false : true);

// const isRepetition = ref(false)
const isPrivate = ref(props.task ? props.task.isPrivate : false)
const hasAlert = ref(props.task ? props.task.hasAlert : false)
const currShowDate = ref(props.task ? props.task.showDateTime : null)
const currTaskBoxId = ref(getInitialTaskBoxId())
const taskPriority = ref(getStartPriorityForNewTask(currTaskBoxId.value))
const currentPwrPatient = ref(props.task?.pwrPatient || props.pwrPatient)

function getInitialTaskBoxId() {
  if (props.task?.taskBox?.taskBoxId) return props.task.taskBox.taskBoxId;
  if (props.task?.patientNoteType) return props.task.patientNoteType;
  if (props.startTaskBox === 'Healthcare') return props.startTaskBox;
  if (props.startTaskBox) {
    const taskBoxId = props.startTaskBox;
    const fullTaskBox = getFullTaskBox(taskBoxId);
    if (fullTaskBox && fullTaskBox.taskBoxChannelType !== 'Results') return props.startTaskBox;
  }
  return getDefaultModuleTaskBox();
}

const pwrCreator = computed(() => {
  if (!props.task) return null
  return props.task.pwrTaskCreator
})

function isPwrCreator(pwr) {
  if (!pwrCreator.value) return false
  return pwrCreator.value.personWithRoleId === pwr.personWithRoleId
}

const isAppUserPwrCreator = computed(() => {
  const pwrAppUser = appUserStore.currentHealthGroupMembership.pwr
  return isPwrCreator(pwrAppUser)
})

async function deleteShowDate() {
  dropd.value = ""
  //Frontend
  currShowDate.value = null
  //Backend
  if (!props.task) return;
  const taskId = props.task.taskId
  emits('changeShowDate', officeapi.updateShowDate(taskId, null))
}

async function changeShowDate(newIso) {
  const oldIso = currShowDate.value
  if (oldIso === newIso) return;
  //Frontend
  currShowDate.value = newIso
  //Backend
  if (!props.task) return;
  const taskId = props.task.taskId
  emits('changeShowDate', officeapi.updateShowDate(taskId, newIso))
}

function getFullTaskBox(taskBoxId) {
  if (['Administrative', 'Healthcare'].includes(taskBoxId)) return null;
  return appUserStore.taskBoxList.find(taskBox => taskBox.taskBoxId === taskBoxId)
}

function getStartPriorityForNewTask(taskBoxId) {
  if (props.task) return props.task.taskPriorityType;
  if (!autoChangePriority.value) return;
  if (['Administrative', 'Healthcare'].includes(taskBoxId)) return 'NextDays';
  const allTaskBoxes = [...appUserStore.taskBoxAssigneeList, ...appUserStore.taskBoxNonAssigneeList]
  const currTaskBox = allTaskBoxes.find(taskBox => taskBox.taskBoxId === taskBoxId)
  return currTaskBox?.taskBoxModuleType === 'Patient'
    ? 'EndOfShift'
    : 'NextDays';
}

async function afterDeactivateTaskBox() {
  currTaskBoxId.value = "";
  await appUserStore.setTaskBoxList();
}

async function changeTaskBox(taskBoxId) {
  currTaskBoxId.value = taskBoxId;
  if (!props.task) {  //only auto-change priority for new tasks
    taskPriority.value = getStartPriorityForNewTask(taskBoxId);
  }
  focus()
  //Backend
  if (!props.task) return;
  const taskId = props.task.taskId
  if (['Healthcare', 'Administrative'].includes(taskBoxId)) {
    emits('changed', officeapi.switchTaskBoxToHealthcare(taskId))
  } else {
    emits('changed', officeapi.switchTaskBox(taskId, taskBoxId))
  }
}

function deletePatient() {
  currentPwrPatient.value = null
  if (['Administrative', 'Healthcare'].includes(currTaskBoxId.value)) {
    currTaskBoxId.value = getDefaultModuleTaskBox()
  }
  focus()
}

function changePatientFct(pwr) {
  currentPwrPatient.value = pwr
  dropd.value = ''
  focus()
}

async function updateHasAlert() {
  //Frontend
  const newHasAlert = !hasAlert.value
  hasAlert.value = newHasAlert
  focus()
  //Backend
  if (!props.task) return;
  const taskId = props.task.taskId
  emits('changed', officeapi.updateHasAlert(taskId, newHasAlert))
}

async function updateIsPrivate() {
  //Frontend
  const newIsPrivate = !isPrivate.value
  isPrivate.value = newIsPrivate
  focus()
  //Backend
  if (!props.task) return;
  const taskId = props.task.taskId
  emits('changed', officeapi.updateIsPrivate(taskId, newIsPrivate))
}

const isPatientNote = computed(() => {
  return ['Administrative', 'Healthcare'].includes(currTaskBoxId.value)
})

const title = computed(() => {
  const pwr = currentPwrPatient.value
  if (pwr) return PersonService.formatName(pwr.lastName, pwr.firstName);
  return t('task.taskTerm');
})

function getDefaultModule() {
  const currRoute = route.name.toString();
  if (['income', 'expenses'].includes(currRoute)) return "Accounting";
  if (['stock', 'orders', 'cart'].includes(currRoute)) return "Stock";
  if (['staff'].includes(currRoute)) return "Staff";
  if (['mycme', 'cmepublication', 'cmevalidation'].includes(currRoute)) return "Learning";
  if (['teaching'].includes(currRoute)) return "Teaching";
  if (['research'].includes(currRoute)) return "Research";
  return "Patient"
}

function getDefaultModuleTaskBox() {
  const currDefaultModule = getDefaultModule()
  const nonAssigneeList = appUserStore.taskBoxNonAssigneeList.filter(tb => tb.taskBoxChannelType !== 'Results')
  const assigneeList = appUserStore.taskBoxAssigneeList.filter(tb => tb.taskBoxChannelType !== 'Results')
  // 1) First match in nonAssigneeList that matches currDefaultModule
  const nonAssigneeMatch = nonAssigneeList.find(taskBox => taskBox.taskBoxModuleType === currDefaultModule)
  if (nonAssigneeMatch) return nonAssigneeMatch.taskBoxId
  // 2) If none found, first item in nonAssigneeList
  if (nonAssigneeList.length > 0) return nonAssigneeList[0].taskBoxId
  // 3) First match in assigneeList that matches currDefaultModule
  const assigneeMatch = assigneeList.find(taskBox => taskBox.taskBoxModuleType === currDefaultModule)
  if (assigneeMatch) return assigneeMatch.taskBoxId
  // 4) If none match, first item in assigneeList
  return assigneeList[0]?.taskBoxId
}

async function addTaskFct() {
  if (props.task) return;
  if (!taskNoteInputRef.value) return;

  const taskBoxId = currTaskBoxId.value
  const taskPriorityType = taskPriority.value
  const taskInfo = taskNoteInputRef.value
  const pwrId = props.pwrPatient?.personWithRoleId || currentPwrPatient.value?.patientId;
  taskNoteInputRef.value = ""

  //Backend
  if (['Healthcare', 'Administrative'].includes(taskBoxId)) {
    await officeapi.createTaskHealthcare(taskInfo, taskPriorityType, pwrId)
  } else {
    await officeapi.createTask(taskBoxId, taskInfo, taskPriorityType, pwrId)
  }
  //Frontend
  emits('changed');
  uiStore.setModalUiId("");
}

async function updateTaskPriority(newType) {
  //Frontend
  autoChangePriority.value = false;
  taskPriority.value = newType;
  focus()
  //BackEnd
  if (!props.task) return;
  emits('changedPriority', {oldPriority: props.task.taskPriorityType, newPriority: newType})
  emits('changed', officeapi.updateTaskPriorityType(props.task.taskId, newType))
}

function focus() {
  if (props.hasInputTaskNote) {
    nextTick(() => {
      focusRef.value.innerRef.focus()
    })
  }
}

const valideTask = (promise: Promise<unknown>) => {
  emits('changedStatus', {oldStatus: props.task.taskStatus, newStatus: TaskStatus.Settled, taskPriority: props.task.taskPriorityType});
  emits('changed', promise);
}

const unvalideTask = (promise: Promise<unknown>) => {
  emits('changedStatus', { oldStatus: TaskStatus.Settled, newStatus: TaskStatus.Pending, taskPriority: undefined});
  emits('changed', promise);
}

onMounted(() => {
  focus()
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_switch_group = _resolveComponent("switch-group")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_inputNewDate = _resolveComponent("inputNewDate")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-primary editTaskGrid shadow rnd-12",
    onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(taskBoxColumn, {
        task: props.task,
        hasPatientOptions: !!currentPwrPatient.value,
        startTaskBox: currTaskBoxId.value,
        onChangeTaskBox: changeTaskBox,
        onAfterDeactivateTaskBox: _cache[0] || (_cache[0] = ($event: any) => (afterDeactivateTaskBox()))
      }, null, 8, ["task", "hasPatientOptions", "startTaskBox"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (props.task)
        ? (_openBlock(), _createBlock(taskNotesChat, {
            key: 0,
            task: props.task,
            onChanged: _cache[1] || (_cache[1] = (p) => emits('changed', p)),
            onValidated: valideTask,
            onUnvalidated: unvalideTask
          }, null, 8, ["task"]))
        : (props.canChangePatient || props.hasInputTaskNote)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_text_item, {
                  txt: title.value,
                  styles: "font-l",
                  class: "mleft-01"
                }, null, 8, ["txt"]),
                (props.canChangePatient)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!currentPwrPatient.value)
                        ? (_openBlock(), _createBlock(_component_dropdownBox, {
                            key: 0,
                            modelValue: dropd.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dropd).value = $event)),
                            openOn: "patientChange",
                            class: "mleft-auto"
                          }, {
                            dropd: _withCtx(() => [
                              _createVNode(patientChange, { onSelectedPatient: changePatientFct })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_buttonGroup, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_svg_item, {
                                    icon: "users",
                                    class: "mtop-01"
                                  }),
                                  _createVNode(_component_text_item, {
                                    txt: _unref(t)('common.patient'),
                                    class: "mleft-03"
                                  }, null, 8, ["txt"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (currentPwrPatient.value)
                        ? (_openBlock(), _createBlock(_component_buttonGroup, {
                            key: 1,
                            class: "mleft-04",
                            style: {"margin-top":"-0.15rem"},
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (deletePatient()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, {
                                icon: "trash",
                                styles: "size-m main-m"
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (props.hasInputTaskNote)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mtop-auto" }, null, -1)),
                    _createVNode(_component_inputBox, { class: "row w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inputAreaAuto2, {
                          ref_key: "focusRef",
                          ref: focusRef,
                          modelValue: taskNoteInputRef.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((taskNoteInputRef).value = $event)),
                          placeholder: "",
                          style: {"width":"25rem"},
                          onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (addTaskFct()), ["exact","prevent"]), ["enter"]))
                        }, null, 8, ["modelValue"]),
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "line-v mleft-auto" }, null, -1)),
                        _createVNode(_component_buttonGroup, {
                          theme: "inline",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (addTaskFct()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_item, {
                              icon: "check",
                              styles: "size-l"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taskPriorityTypes), (taskPriorityType, index) => {
            return (_openBlock(), _createBlock(_component_switch_group, {
              key: index,
              active: taskPriority.value === taskPriorityType,
              class: "w-maxC",
              styles: "pad-s",
              onClick: ($event: any) => (updateTaskPriority(taskPriorityType))
            }, {
              default: _withCtx(() => [
                (isPatientNote.value)
                  ? (_openBlock(), _createBlock(_component_text_item, {
                      key: 0,
                      txt: _unref(t)(`task.notePriority.${taskPriorityType}`),
                      class: _normalizeClass(taskPriority.value === taskPriorityType ? 'txt-white' : '')
                    }, null, 8, ["txt", "class"]))
                  : (_openBlock(), _createBlock(_component_text_item, {
                      key: 1,
                      txt: _unref(t)(`task.taskPriority.${taskPriorityType}`),
                      class: _normalizeClass(taskPriority.value === taskPriorityType ? 'txt-white' : '')
                    }, null, 8, ["txt", "class"]))
              ]),
              _: 2
            }, 1032, ["active", "onClick"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dropd).value = $event)),
              openOn: "editShowDate"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", {
                  class: "bg-modal w-maxC",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createVNode(_component_inputNewDate, {
                    dateIso: currShowDate.value || new Date().toString(),
                    isNew: !currShowDate.value,
                    calendar: false,
                    trash: true,
                    onDelete: _cache[8] || (_cache[8] = ($event: any) => (deleteShowDate())),
                    onChanged: changeShowDate
                  }, null, 8, ["dateIso", "isNew"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_switchGroup, {
                    active: !!currShowDate.value,
                    circle: true,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (dropd.value = 'editShowDate'))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: "calendar",
                        styles: "size-m main-h",
                        class: _normalizeClass(!!currShowDate.value ? 'img-white' : '')
                      }, null, 8, ["class"])
                    ]),
                    _: 1
                  }, 8, ["active"]),
                  _createVNode(_component_text_item, {
                    txt: currShowDate.value ? _unref(apiDateString)(currShowDate.value) : _unref(t)('task.since'),
                    styles: "font-m main-m",
                    class: "mleft-04"
                  }, null, 8, ["txt"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (currTaskBoxId.value === 'Healthcare' && isAppUserPwrCreator.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_switchGroup, {
                  active: isPrivate.value,
                  circle: true,
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (updateIsPrivate()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "lock",
                      styles: "size-m main-m",
                      class: _normalizeClass(isPrivate.value ? 'img-white' : '')
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["active"]),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('task.private'),
                  styles: "font-m main-m",
                  class: "mleft-04"
                }, null, 8, ["txt"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})